module.exports = __webpack_public_path__ + "static/img/lihuowang.097fcc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lihuowang.png
// module id = X/I3
// module chunks = 44